import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import { TokenRefreshInterceptor } from './modules/auth/services/auth.interceptor';
import { ApiNetworkOnlyInterceptor } from './core/interceptors/api-network-only.interceptor';
import { HttpErrorToastInterceptor } from './core/http-error-toast/http-error-toast.interceptor';
import { HttpErrorToastHostComponent } from './core/http-error-toast/http-error-toast-host.component';
import { ConnectionWarningComponent } from './core/connection-warning/connection-warning.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

function appInitializer(authService: AuthService) {
  return () => firstValueFrom(authService.getUserByToken(), { defaultValue: undefined })
    .catch(() => undefined);
}

@NgModule({
  declarations: [AppComponent, ConnectionWarningComponent, HttpErrorToastHostComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    SweetAlert2Module.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:3000',
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiNetworkOnlyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorToastInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
